export const actionTypes = {
  GET_EZDS: "GET_EZDS",
  SET_EZDS: "SET_EZDS",
  GET_MCDS: "GET_MCDS",
  SET_MCDS: "SET_MCDS",

  GET_EZD_ROLLBACK_INGESTIONS: "GET_EZD_ROLLBACK_INGESTIONS",
  SET_EZD_ROLLBACK_INGESTIONS: "SET_EZD_ROLLBACK_INGESTIONS",
  
  GET_MCD_ROLLBACK_INGESTIONS: "GET_MCD_ROLLBACK_INGESTIONS",
  SET_MCD_ROLLBACK_INGESTIONS: "SET_MCD_ROLLBACK_INGESTIONS",

  GET_INGESTION_DETAILS: "GET_INGESTION_DETAILS",
  SET_INGESTION_DETAILS: "SET_INGESTION_DETAILS",

  ROLLBACK_INGESTION: "ROLLBACK_INGESTION",
  RESET_ACCOUNT_BALANCE: "RESET_ACCOUNT_BALANCE",
  CUSTOMER_DELETION: "CUSTOMER_DELETION",

  ROLLBACK_POPUP_OPEN: "ROLLBACK_POPUP_OPEN",
  ROLLBACK_LOADER: "ROLLBACK_LOADER"
};

export const actions = {
  getEzds: (payload) => ({
    type: actionTypes.GET_EZDS,
    payload: payload,
  }),

  setEzds: (payload) => ({
    type: actionTypes.SET_EZDS,
    payload: payload,
  }),

  getMcds: (payload) => ({
    type: actionTypes.GET_MCDS,
    payload: payload,
  }),

  setMcds: (payload) => ({
    type: actionTypes.SET_MCDS,
    payload: payload,
  }),

  getEzdRollbackIngestions: (payload) => ({
    type: actionTypes.GET_EZD_ROLLBACK_INGESTIONS,
    payload: payload,
  }),

  setEzdRollbackIngestions: (payload) => ({
    type: actionTypes.SET_EZD_ROLLBACK_INGESTIONS,
    payload: payload,
  }),

  getMcdRollbackIngestions: (payload) => ({
    type: actionTypes.GET_MCD_ROLLBACK_INGESTIONS,
    payload: payload,
  }),

  setMcdRollbackIngestions: (payload) => ({
    type: actionTypes.SET_MCD_ROLLBACK_INGESTIONS,
    payload: payload,
  }),

  getIngestionDetails: (payload) => ({
    type: actionTypes.GET_INGESTION_DETAILS,
    payload: payload,
  }),

  setIngestionDetails: (payload) => ({
    type: actionTypes.SET_INGESTION_DETAILS,
    payload: payload,
  }),

  rollbackIngestion: (payload) => ({
    type: actionTypes.ROLLBACK_INGESTION,
    payload: payload,
  }),

  resetAccountBalance: (payload) => ({
    type: actionTypes.RESET_ACCOUNT_BALANCE,
    payload: payload,
  }),

  customerDeletion: (payload) => ({
    type: actionTypes.CUSTOMER_DELETION,
    payload: payload,
  }),

  rollbackPopupOpen: (payload) => ({
    type: actionTypes.ROLLBACK_POPUP_OPEN,
    payload: payload,
  }),

  rollbackLoader: (payload) => ({
    type: actionTypes.ROLLBACK_LOADER,
    payload: payload,
  }),
};
